import React from 'react';
import { LABEL, BlockLabel, colors, TagDisplayV2, UI_BODY_SEMIBOLD } from "oolib";
import TagsInputMulti from '../../../../../components/inputs/DynamicTagsInputs/TagsInputMulti';

const getTagLabel = (tagKey, allTpls) => {
  const tpl = allTpls.find(d => d.kp_content_type === tagKey);
  return tpl?.general?.content?.title || tagKey;
};

const TAG_FIELDS = ['subject', 'stakeholder', 'country', 'states', 'districts', 'teams'];

const TagsSection = ({ activeItem, allTpls }) => {
  return (
    <div>
      <div style={{ position: 'sticky', top: 0, backgroundColor: colors.greyColor5, padding: '0.5rem 0 1rem', width: '100%', zIndex: 1 }}>
        <LABEL>TAGS</LABEL>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
        <div>
          <BlockLabel label="Content Type" readOnly/>
          <TagDisplayV2
            display={
              allTpls.find(
                (d) => d.kp_content_type === activeItem.metaData?.contentType
              )?.general?.content?.title
            }
          />
        </div>
        {activeItem.metaData?.facilityType && (
          <div>
            <BlockLabel label={getTagLabel('facilityType', allTpls)} readOnly />
            <TagDisplayV2
              display={activeItem.metaData?.facilityType.display}
            />
          </div>
        )}
        {TAG_FIELDS.map(field =>
          activeItem.metaData?.[field]?.data?.length > 0 && (
            <TagsInputMulti
              key={field}
              label={getTagLabel(field, allTpls)}
              readOnly
              value={activeItem.metaData[field]}
            />
          )
        )}
      </div>
    </div>
  );
};

export default TagsSection;
